module.exports = __webpack_public_path__ + "static/img/3.97c0fbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/zh/3.png
// module id = zd2x
// module chunks = 0